export default [
  {
    name: 'Anne Watson',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/awatson.jpg`,
    description: `Dr. Anne Watson taught mathematics for several years before
    taking a position at the University of Oxford. Anne’s research addresses
    task design in mathematics teaching and learning, the role of mathematics
    education in social justice, and the use of fine-grained questions and
    prompts to shift adolescent thinking towards abstract mathematical
    ideas.`,
  },
  {
    name: 'Dr. Joanne (Jo) Boaler',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/jboaler.jpg`,
    description: `Dr. Joanne (Jo) Boaler is a professor in the School of
    Education at Stanford University, focusing on mathematics education. Her
    research addresses mathematics teaching and learning, gender and
    learning, and the role of groupwork and mathematical discussions in the
    development of understanding.`,
  },
  {
    name: 'Brad Findell',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/bfindell.jpg`,
    description: `Dr. Brad Findell serves as Associate Director of
    Mathematics Programs for Teachers in the Department of Mathematics at The
    Ohio State University, where he develops and teaches mathematics courses
    for teachers, with an eye toward the implementation of the Common Core
    State Standards.`,
  },
  {
    name: 'Doug Carlston',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/dcarlston.jpg`,
    description: `Doug co-founded Broderbund Software, one of the world’s
    leading publishers of productivity and educational software, and served
    as Broderbund CEO and Chairman of the Board. He currently serves as CEO
    of Tawala Systems, which he founded in 2005. Doug also serves on several
    boards, including Internews, the Ploughshares Fund, and the Long Now
    Foundation. He has BA and JD degrees from Harvard University, and he has
    authored several books.`,
  },
  {
    name: 'Harri Ketamo',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/hketamo.jpg`,
    description: `Dr. Harri Ketamo is a Founder and Chief Scientist at
    SkillPixels Ltd, a leading Finnish-based designer of educational video
    games. He is also Senior Fellow at the University of Turku and an Adjunct
    Professor at Tampere University of Technology.`,
  },
  {
    name: 'Heli Ruokamo',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/hruokamo.jpg`,
    description: `Dr. Heli Ruokamo specializes in media education and is the
    Director of the University of Lapland’s Centre for Media Pedagogy. A
    leading member of the Finnish multidisciplinary CICERO Learning research
    network, Heli received her M.A. in education from the University of
    Lapland and a Ph.D. from the University of Helsinki.`,
  },
  {
    name: 'Wade Ellis, Jr.',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/wellis.jpg`,
    description: `Dr. Wade Ellis, Jr. taught mathematics at West Valley
    College in San Jose, California for over 30 years. He is a co-author of
    more than 30 books on the learning and teaching of mathematics using
    technology and has received numerous awards recognizing his lifetime
    achievement.`,
  },
  {
    name: 'John Romero',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/jromero.jpg`,
    description: [
      `John is a legendary game designer, programmer, and artist whose work
      spans over 130 games, 107 of which have been published commercially,
      including the iconic works Wolfenstein 3D, DOOM, and Quake. He has
      worked in the mobile, core, mid-core, casual, social, and MMO spaces.`,
      `A serial entrepreneur who has founded eight successful companies, his
      contributions and philanthropy within the commercial game industry have
      inspired the creation of numerous games and companies. He is among the
      world’s top game designers, and his products have won every major
      award.`,
    ],
  },
  {
    name: 'John Mason',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/jmason.gif`,
    description: `Dr. John Mason has a BSc in mathematics from Trinity
    College, Toronto, and an MSc from Massey College, Toronto, and earned his
    Ph.D. at the University of Wisconsin at Madison. His principal focus is
    thinking about mathematical problems, and supporting others who wish to
    foster and sustain cognitive thinking skills.`,
  },
  {
    name: 'Johnny Lott',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/jlott.jpg`,
    description: `Dr. Johnny W. Lott is former Director, Center for
    Excellence in Teaching and Learning, Professor of Education, and
    Professor of Mathematics at the University of Mississippi. He is also a
    past Board Member and President of the National Council of Teachers of
    Mathematics.`,
  },
  {
    name: 'Roberto Araya',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/raraya.jpg`,
    description: `Dr. Roberto Araya has a Ph.D. in Electrical Engineering from
    UCLA and is a researcher at the Center for Advanced Research on
    Education, University of Chile. He is the founder of a Chilean company
    that runs online web-based mathematics teaching in ten Chilean schools.`,
  },
  {
    name: 'Russ Glaser',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/rglaser.jpg`,
    description: `Russ spent the first part of his career designing,
    installing, and shipping playful educational exhibits and products for
    the Smithsonian, Maui Ocean Center, and the California Academy of
    Sciences. For the past 12 years, he’s led design teams for Xbox One, Xbox
    Live, Xbox 360, Xbox.com, and Amazon Digital Products.`,
  },
  {
    name: 'Tom Davis',
    title: null,
    image: `${process.env.PUBLIC_URL}/assets/img/advisors/tdavis.jpg`,
    description: `Dr. Tom Davis studied mathematics at Caltech and Stanford
    and then spent two years as a post-doc in the Stanford Electrical
    Engineering department. He was a founder and Principal Scientist at
    Silicon Graphics. For 15 years, he has coached middle- and high-school
    students, as well as middle school teachers, to apply problem-solving
    techniques in mathematics.`,
  },
];
